import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { type FC, useId } from "react";

import * as Buttons from "~/feature/citeEmbed/citeEmbed.styles";
import { NEWSLETTER_SOURCE, STAY_ON_TOP } from "~/feature/citeEmbed/constants";
import { useGetUpdatesForm } from "~/feature/getUpdates/components/GetUpdatesForm/useGetUpdatesForm";

import * as Styled from "./StayOnTop.styles";

export const StayOnTop: FC = () => {
  const { formik, submittedEmail, showRecaptchaError } =
    useGetUpdatesForm(NEWSLETTER_SOURCE);
  const errorId = useId();
  const emailError = formik.touched.email ? formik.errors.email : undefined;
  const error = showRecaptchaError ? formik.errors.recaptchaToken : emailError;

  return (
    <Styled.Root>
      <Styled.Title>{STAY_ON_TOP.title}</Styled.Title>
      {submittedEmail ? (
        <Styled.Subscribed role="status">
          <CheckCircleOutlinedIcon />
          {STAY_ON_TOP.subscribed}
        </Styled.Subscribed>
      ) : (
        <>
          <Styled.Form onSubmit={formik.handleSubmit} noValidate>
            <Styled.Email
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              placeholder={STAY_ON_TOP.emailPlaceholder}
              aria-label={STAY_ON_TOP.emailLabel}
              aria-invalid={Boolean(error)}
              aria-describedby={error ? errorId : undefined}
              autoComplete="email"
              readOnly={formik.isSubmitting}
            />
            <Buttons.InkButton type="submit" disabled={formik.isSubmitting}>
              {formik.isSubmitting
                ? STAY_ON_TOP.sending
                : STAY_ON_TOP.subscribe}
            </Buttons.InkButton>
          </Styled.Form>
          {error && <Styled.FieldError id={errorId}>{error}</Styled.FieldError>}
        </>
      )}
    </Styled.Root>
  );
};
